"use client";
export function onKeyDownInputHandlers(e) {
    e.stopPropagation();
}
